import React from 'react';
import { ENUM_PAYMENT_STATUS } from 'models/common.model';
import { DEFAULT_TAG, PAYMENT_STATUS_TAG } from 'utils/constants';

interface PaymentStatusTagProps {
  status?: ENUM_PAYMENT_STATUS;
}

const PaymentStatusTag: React.FC<PaymentStatusTagProps> = ({
  status = ENUM_PAYMENT_STATUS.PENDING
}) => {
  const { bgColor, text, textColor } = PAYMENT_STATUS_TAG[status] || DEFAULT_TAG;

  return (
    <div
      style={{
        backgroundColor: bgColor,
        color: textColor
      }}
      className='flex items-center gap-1 capitalize rounded-[40px] font-medium text-xs leading-[19px] px-3 py-1'>
      <p
        className='w-[8px] h-[8px] rounded-full'
        style={{
          backgroundColor: textColor
        }}
      />
      {text || status?.toLowerCase()}
    </div>
  );
};

export default PaymentStatusTag;
